document.addEventListener('DOMContentLoaded', function () {
    const scrollSliders = document.querySelectorAll('.scroll-image-slider');

    scrollSliders.forEach(function (sliderContainer) {
        const textSlides = sliderContainer.querySelectorAll('.scroll-slide');
        const imageStrip = sliderContainer.querySelector('.scroll-slider-image-sticky');
        const totalSlides = textSlides.length;
        const TOP_OFFSET = 150;
        const MOBILE_BREAKPOINT = 1200;

        if (totalSlides === 0 || !imageStrip) return;

        function isMobile() {
            return window.innerWidth <= MOBILE_BREAKPOINT;
        }

        function getImageHeight() {
            return window.innerHeight - TOP_OFFSET;
        }

        function initDesktop() {
            sliderContainer.style.height = `${totalSlides * 100}vh`;
            imageStrip.style.height = `${totalSlides * getImageHeight()}px`;
        }

        function resetMobile() {
            sliderContainer.style.height = '';
            imageStrip.style.height = '';
            imageStrip.style.transform = '';
        }

        function buildMobileLayout() {
            const container = sliderContainer.querySelector('.scroll-slider-container');
            if (!container || container.dataset.mobileBuilt) return;
            container.dataset.mobileBuilt = 'true';
        
            const images = Array.from(sliderContainer.querySelectorAll('.scroll-slide-image'));
            const slides = Array.from(textSlides);
            const header = container.querySelector('.scroll-slider-header');
        
            // Move header before the slider container, not inside it
            if (header) {
                sliderContainer.insertBefore(header, container);
            }
        
            container.innerHTML = '';
            container.style.cssText = 'display:block;position:static;height:auto;overflow:visible;';
        
            slides.forEach(function (slide, index) {
                const img = images[index];
                if (img) {
                    const imgWrapper = document.createElement('div');
                    imgWrapper.style.cssText = 'width:100%;aspect-ratio:1/1;overflow:hidden;';
                    const imgEl = img.querySelector('img');
                    if (imgEl) {
                        imgEl.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
                        imgWrapper.appendChild(imgEl);
                    }
                    container.appendChild(imgWrapper);
                }
                slide.style.cssText = 'position:static;opacity:1;transform:none;padding:1.5rem 0 2rem;pointer-events:auto;width:100%;box-sizing:border-box;';
                container.appendChild(slide);
            });
        }

        if (isMobile()) {
            buildMobileLayout();
            resetMobile();
        } else {
            initDesktop();
        }

        let currentActiveIndex = 0;
        let ticking = false;

        function buildDots() {
            const dotsWrapper = document.createElement('div');
            dotsWrapper.className = 'scroll-slider-dots';
            dotsWrapper.setAttribute('aria-hidden', 'true');  // ← add this line
            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement('button');
                dot.className = 'scroll-slider-dot' + (i === 0 ? ' active' : '');
                dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
                dot.setAttribute('aria-hidden', 'true'); // ← add this
                dot.addEventListener('click', function () { goToSlide(i); });
                dotsWrapper.appendChild(dot);
            }
            const stickyContainer = sliderContainer.querySelector('.scroll-slider-container');
            if (stickyContainer) stickyContainer.appendChild(dotsWrapper);
            return dotsWrapper.querySelectorAll('.scroll-slider-dot');
        }

        const dots = isMobile() ? [] : buildDots();

        function goToSlide(index) {
            const containerTop = sliderContainer.getBoundingClientRect().top + window.scrollY;
            const containerHeight = sliderContainer.offsetHeight;
            const scrollable = containerHeight - window.innerHeight;
            const targetProgress = totalSlides > 1 ? index / (totalSlides - 1) : 0;
            window.scrollTo({ top: containerTop + targetProgress * scrollable, behavior: 'smooth' });
        }

        function activateSlide(index) {
            const previous = currentActiveIndex;
            if (index === previous) return;

            const direction = index > previous ? 1 : -1;

            if (textSlides[previous]) {
                textSlides[previous].classList.remove('active');
                textSlides[previous].classList.add(direction > 0 ? 'exit-up' : 'exit-down');
                const exiting = textSlides[previous];
                setTimeout(function () {
                    exiting.classList.remove('exit-up', 'exit-down');
                }, 500);
            }

            if (textSlides[index]) textSlides[index].classList.add('active');

            Array.from(dots).forEach(function (dot, i) {
                dot.classList.toggle('active', i === index);
            });

            currentActiveIndex = index;
            announceSlideChange(index);
        }

        function updateSlides() {
            if (isMobile()) {
                ticking = false;
                return;
            }

            const rect = sliderContainer.getBoundingClientRect();
            const containerHeight = sliderContainer.offsetHeight;
            const viewportHeight = window.innerHeight;
            const scrollable = containerHeight - viewportHeight;

            let progress = 0;
            if (scrollable > 0) {
                progress = Math.max(0, Math.min(1, -rect.top / scrollable));
            }

            const snappedIndex = Math.max(0, Math.min(totalSlides - 1, Math.round(progress * (totalSlides - 1))));

            imageStrip.style.transform = `translateY(${-(snappedIndex * getImageHeight())}px)`;
            sliderContainer.style.backgroundColor = '#fff';
            activateSlide(snappedIndex);

            ticking = false;
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(updateSlides);
                ticking = true;
            }
        }

        function announceSlideChange(index) {
            let el = sliderContainer.querySelector('.scroll-slider-announcement');
            if (!el) {
                el = document.createElement('div');
                el.className = 'scroll-slider-announcement';
                el.setAttribute('role', 'status');
                el.setAttribute('aria-live', 'polite');
                el.setAttribute('aria-atomic', 'true');
                el.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);';
                sliderContainer.appendChild(el);
            }
            el.textContent = `Viewing slide ${index + 1} of ${totalSlides}`;
        }

        sliderContainer.setAttribute('role', 'region');
        sliderContainer.setAttribute('aria-label', 'Scroll-triggered image slider');
        textSlides.forEach(function (slide, index) {
            slide.setAttribute('aria-label', `Slide ${index + 1} of ${totalSlides}`);
        });

        window.addEventListener('keydown', function (e) {
            if (isMobile()) return;
            const rect = sliderContainer.getBoundingClientRect();
            if (rect.top > 0 || rect.bottom < window.innerHeight) return;
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                e.preventDefault();
                goToSlide(Math.min(currentActiveIndex + 1, totalSlides - 1));
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                e.preventDefault();
                goToSlide(Math.max(currentActiveIndex - 1, 0));
            }
        });

        if (!isMobile()) {
            if (textSlides[0]) textSlides[0].classList.add('active');
            updateSlides();
        }

        window.addEventListener('scroll', onScroll, { passive: true });

        window.addEventListener('resize', function () {
            if (isMobile()) {
                buildMobileLayout();
                resetMobile();
            } else {
                initDesktop();
                if (!ticking) {
                    window.requestAnimationFrame(updateSlides);
                    ticking = true;
                }
            }
        }, { passive: true });
    });
});